const PAYMENT_STATUS = {
  CLEAN: 'CLEAN',
  NEW: 'NEW',
  PENDING: 'PENDING',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  WAITING: 'WAITING',
};

Object.freeze(PAYMENT_STATUS);

export { PAYMENT_STATUS };


// WEBPACK FOOTER //
// ./client/app/shared/enum/PaymentStatusEnum.js